import { useState } from "react";
import { observer } from "mobx-react-lite";
import { Link, NavLink } from "react-router-dom";
import { useTranslation } from "../i18n/useTranslation.js";
import { PRODUCT_CONFIG } from "../config/productConfig.js";
import LanguageSwitch from "./LanguageSwitch.js";

const navItems = [
  { path: "/about", key: "landing.nav.about" },
  { path: "/roadmap", key: "landing.nav.roadmap" },
  { path: "/news", key: "landing.nav.news" },
];

const LandingHeader = observer(() => {
  const { t } = useTranslation();
  const [menuOpen, setMenuOpen] = useState(false);
  const closeMenu = () => setMenuOpen(false);
  return (
    <header className="landing-header">
      <Link className="landing-brand" to="/" onClick={closeMenu}>
        <img className="landing-brand-logo" src="/narrata-mark.png" alt="" width="36" height="36" />
        <span>{PRODUCT_CONFIG.name.slice(1, PRODUCT_CONFIG.name.length)}</span>
      </Link>
      <button className="landing-menu-toggle" type="button" aria-expanded={menuOpen}
        aria-controls="landing-navigation" onClick={() => setMenuOpen((open) => !open)}>
        <span className="sr-only">{t("landing.nav.menu")}</span>
        <span aria-hidden="true" />
        <span aria-hidden="true" />
      </button>
      <nav id="landing-navigation" className={menuOpen ? "landing-nav is-open" : "landing-nav"}
        aria-label={t("landing.nav.primary")}>
        <LanguageSwitch />
        {navItems.map((item) => (
          <NavLink key={item.path} to={item.path} onClick={closeMenu}>
            {t(item.key)}
          </NavLink>
        ))}
        <a className="landing-login-link" href={PRODUCT_CONFIG.loginPath} onClick={closeMenu}>
          {t("landing.nav.enter")}
        </a>
      </nav>
    </header>
  );
});

export default LandingHeader;
